import {
  OTP_VERIFY_REQUEST,
  OTP_VERIFY_SUCCESS,
  OTP_VERIFY_FAILURE,
  SET_RESET_TOKEN,
} from './actions';

const initialState = {
  resetToken: null,
};

export default function otpVerifyReducer(state = initialState, action) {
  switch (action.type) {
    case OTP_VERIFY_REQUEST:
      return { ...state, resetToken: null };
    case OTP_VERIFY_SUCCESS:
      return { ...state, resetToken: null };
    case OTP_VERIFY_FAILURE:
      return { ...state, resetToken: null };
    case SET_RESET_TOKEN:
      return { ...state, resetToken: action.payload };
    default:
      return state;
  }
}
